import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Layout } from '@/components/Layout';
import { byoaEnabled } from '@/lib/flags';
import { ProtectedRoute } from './ProtectedRoute';

const LandingPage = lazy(() =>
  import('@/pages/LandingPage').then((m) => ({ default: m.LandingPage })),
);
const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
const ProfilePage = lazy(() =>
  import('@/pages/ProfilePage').then((m) => ({ default: m.ProfilePage })),
);
const InvitePage = lazy(() =>
  import('@/pages/InvitePage').then((m) => ({ default: m.InvitePage })),
);
const OrgDetailPage = lazy(() =>
  import('@/pages/OrgDetailPage').then((m) => ({ default: m.OrgDetailPage })),
);
const ChannelDetailPage = lazy(() =>
  import('@/pages/ChannelDetailPage').then((m) => ({ default: m.ChannelDetailPage })),
);
const AppDetailPage = lazy(() =>
  import('@/pages/AppDetailPage').then((m) => ({ default: m.AppDetailPage })),
);
const SandboxPage = lazy(() =>
  import('@/pages/SandboxPage').then((m) => ({ default: m.SandboxPage })),
);
const SubPage = lazy(() =>
  import('@/pages/SubPage').then((m) => ({ default: m.SubPage })),
);
const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);

export function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/sub/*" element={<SubPage />} />
        <Route element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="/invites/:token" element={<InvitePage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orgs/:org_ref"
            element={
              <ProtectedRoute>
                <OrgDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orgs/:org_ref/channels/*"
            element={
              <ProtectedRoute>
                <ChannelDetailPage />
              </ProtectedRoute>
            }
          />
          {byoaEnabled() && (
            <Route
              path="/orgs/:org_ref/apps/:app_ref"
              element={
                <ProtectedRoute>
                  <AppDetailPage />
                </ProtectedRoute>
              }
            />
          )}
          {byoaEnabled() && (
            <Route
              path="/orgs/:org_ref/apps/:app_ref/sandbox"
              element={
                <ProtectedRoute>
                  <SandboxPage />
                </ProtectedRoute>
              }
            />
          )}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
